;(function () {
   'use strict'

   angular.module('internalWebsiteApp').directive('bartenderPrintConfigTab', Directive)

   function Directive() {
      return {
         restrict: 'E',
         templateUrl: 'modules/bartender/tabs/printconfig/printconfig.html',
         controller: ['AzureAPI', 'alert', 'ENV', '$window', '$http', Controller],
         controllerAs: 'configTab',
      }
   }

   function Controller(AzureAPI, alert, ENV, $window, $http) {
      var configTab = this

      // --- Get Data ----------------------------------------------------------

      configTab.configs = []
      configTab.facilities = []
      configTab.printers = []
      configTab.templates = []
      configTab.hosts = []
      configTab.uploadPrintRequestCsvSelectedConfig = undefined

      // =========================================================================
      // FCE_FACILITY_GATE (temporary) — remove after FCE is live in production.
      // Search the printconfig module for "FCE_FACILITY_GATE" and delete the gate:
      // keep facilities loading + UI, drop facilityAware / stripFacilityForPreFce,
      // and restore .catch(alert.catchNetwork('Facilities')) on getFacilities.
      // =========================================================================
      configTab.facilityAware = false

      function getConfigs() {
         configTab.configs = AzureAPI['bartender-print-configuration'].query({limit: "none"})
         configTab.configs.$promise.catch(alert.catchNetwork('Print Configurations'))
      }

      function getPrinters() {
         var printerOptions = {
            limit: 250,
            delivery: 'bartender',
            format: 'bartender',
         }
         configTab.printers = AzureAPI.printer.query(printerOptions)
         configTab.printers.$promise.catch(alert.catchNetwork('Printers'))
      }

      function getTemplates() {
         configTab.templates = AzureAPI['bartender-template'].query({limit: 250})
         configTab.templates.$promise.catch(alert.catchNetwork('Templates'))
      }

      function getHosts() {
         configTab.hosts = AzureAPI['bartender-host'].query({limit: 250})
         configTab.hosts.$promise.catch(alert.catchNetwork('Hosts'))
      }

      function getFacilities() {
         // User-associated facilities (same source as Beehive's facility selector).
         // FCE_FACILITY_GATE: success enables Facility UI; failure keeps pre-FCE UX.
         $http
            .get(ENV.apiEndpoint + '/v2/current-facility/facilities', {withCredentials: true})
            .then(function (response) {
               configTab.facilities = response.data
               configTab.facilityAware = true // FCE_FACILITY_GATE
            })
            .catch(function () {
               // FCE_FACILITY_GATE: pre-FCE backends 404 this endpoint — degrade
               // silently (no toast). After FCE ships, replace this catch with
               // alert.catchNetwork('Facilities') and remove the gate.
               configTab.facilityAware = false
               configTab.facilities = []
            })
      }

      // FCE_FACILITY_GATE: omit facility on writes while the pre-FCE API is live.
      function stripFacilityForPreFce(data) {
         if (!configTab.facilityAware && data && Object.prototype.hasOwnProperty.call(data, 'facility')) {
            delete data.facility
         }
         return data
      }

      // --- Process Data -------------------------------------------------------

      configTab.getPrinter = function (id) {
         return findItemById('printers', id)
      }

      configTab.getTemplate = function (id) {
         return findItemById('templates', id)
      }

      configTab.getHost = function (code) {
         return findItemById('hosts', code, 'code')
      }

      configTab.getFacility = function (id) {
         return findItemById('facilities', id)
      }

      function findItemById(list, id, identifier) {
         var rtn = {}
         var list = configTab[list]
         identifier = identifier || 'id'
         for (var i = 0; i < list.length; i++) {
            if (list[i][identifier] === id) {
               rtn = list[i]
               break
            }
         }
         return rtn
      }

      // --- Create New Config --------------------------------------------------

      configTab.newConfig = {}

      configTab.toggleNewForm = function () {
         configTab.showNewForm = !configTab.showNewForm
      }

      configTab.createConfig = function () {
         if (configTab.newConfigForm.$invalid) {
            return
         }
         // FCE_FACILITY_GATE: copy + strip so pre-FCE create ignores facility.
         var payload = stripFacilityForPreFce(angular.copy(configTab.newConfig))
         var newConfig = AzureAPI['bartender-print-configuration'].create(payload)
         newConfig.$promise
            .then(function () {
               configTab.configs.unshift(newConfig)
               console.log('createConfig: ', newConfig)
               configTab.clearNewConfig()
            })
            .catch(alert.catchNetwork('Bartender Print Configuration'))
      }

      configTab.clearNewConfig = function () {
         configTab.newConfig = {}
         configTab.showNewForm = false
      }

      // --- Manage Configs -----------------------------------------------------

      configTab.editView = {}
      var stashedConfig = {}

      configTab.sendTestPrint = function (config) {
         var options = {
            id: config.id,
            stock: configTab.testStockId,
         }
         var testPrint = AzureAPI['bartender-print-configuration'].testPrint(options)
         testPrint.$promise
            .then(function () {
               alert.add('success', 'Your test print request has been sent.')
            })
            .catch(alert.catchNetwork('Test Print'))
      }

      configTab.removeConfig = function (config, index) {
         config
            .$delete()
            .then(function () {
               configTab.configs.splice(index, 1)
            })
            .catch(alert.catchNetwork('Print Configurations'))
      }

      configTab.editConfig = function (config) {
         stashedConfig = angular.copy(config)
         configTab.editView[config.id] = true
      }

      configTab.cancelEditConfig = function (config, index) {
         configTab.configs[index] = stashedConfig
         clearEditConfig(config.id)
      }

      configTab.saveConfig = function (config) {
         // FCE_FACILITY_GATE: don't PUT facility to the pre-FCE API.
         stripFacilityForPreFce(config)
         config
            .$save()
            .then(function () {
               clearEditConfig(config.id)
            })
            .catch(alert.catchNetwork('Print Configurations'))
      }

      function clearEditConfig(configId) {
         configTab.editView[configId] = false
         stashedConfig = {}
      }

      // --- Bulk Create Print Requests with CSV --------------------------------

      function fileInputId() {
         return configTab.uploadPrintRequestCsvSelectedConfig !== undefined
            ? `fileInput-${configTab.uploadPrintRequestCsvSelectedConfig.id}`
            : ''
      }

      configTab.uploadPrintRequestCsv = function (config) {
         configTab.uploadPrintRequestCsvSelectedConfig = config
         const hiddenInput = document.getElementById(fileInputId())
         if (!hiddenInput.dataset.changeListenerAttached) {
            hiddenInput.addEventListener('change', function () {
               uploadFile()
            })
            hiddenInput.dataset.changeListenerAttached = true
         }
         hiddenInput.click()
      }

      function uploadFile() {
         const fileInput = document.getElementById(fileInputId())
         if (fileInput.files.length === 0) {
            return
         }
         const file = fileInput.files[0]
         const reader = new FileReader()
         reader.readAsArrayBuffer(file)
         reader.onload = function () {
            const request = new XMLHttpRequest()
            request.onload = function () {
               if (request.status >= 200 && request.status < 300) {
                  let message = 'CSV upload was successful!!'
                  // The API reports rows it skipped (e.g. product codes with
                  // no stock) in a message on the 200 response.
                  try {
                     const body = JSON.parse(request.responseText)
                     if (body && body.message) {
                        message += '\n\n' + body.message
                     }
                  } catch (e) {
                     // No JSON body -- plain success.
                  }
                  $window.alert(message)
               } else {
                  $window.alert(
                     'CSV upload was not successful. Please contact production support. ' + request.responseText,
                  )
               }
            }
            request.onerror = function () {
               $window.alert('CSV upload was not successful. Please contact production support.')
            }
            request.withCredentials = true
            const printConfigId = configTab.uploadPrintRequestCsvSelectedConfig.id
            request.open(
               'POST',
               `${ENV.apiEndpoint}/v2/bartender/csv-bulk-create?print_configuration_id=${printConfigId}`,
               true,
            )
            request.setRequestHeader('Content-Disposition', 'attachment; filename="' + file.name + '"')
            request.setRequestHeader('Content-Type', 'application/octet-stream')
            request.send(file)
            fileInput.value = null
         }
         reader.onerror = function (error) {
            console.error('Error reading file:', error)
         }
      }

      // --- Initialization -----------------------------------------------------

      function init() {
         configTab.clearNewConfig()
         getHosts()
         getPrinters()
         getTemplates()
         getFacilities()
         getConfigs()
      }
      init()
   }
})()
